import { SEARCH_TYPES, SELECTOR_MODE } from '../constants';

/**ボトムシート表示切り替え
 * @const ['none', 'parking', 'prefecture', 'city', 'areaParking'] - 未選択, 住所・駐車場名から探す, 都道府県で探す, エリアで探す, エリアの駐車場名から探す
 */
export const selectorModeValue = [
  SELECTOR_MODE.NONE,
  SELECTOR_MODE.PARKING,
  SELECTOR_MODE.PREFECTURE,
  SELECTOR_MODE.CITY,
  SELECTOR_MODE.AREA_PARKING,
] as const;
export type SelectorMode = (typeof selectorModeValue)[number];

// 駐車場リストの検索タイプ
export const searchTypeValue = [
  'currentPlace',
  'address',
  'parkingName',
  'selectedAddress',
] as const;

/**
 * 検索タイプのユニオン型
 *
 * - `currentPlace`: 現在の場所で検索する
 * - `address`: 住所のキーワードで検索する
 * - `parkingName`: 駐車場名のキーワードで検索する
 * - `selectedAddress`: エリア検索で選択した市区町村で検索する
 */
export type SearchType = (typeof SEARCH_TYPES)[keyof typeof SEARCH_TYPES];

/** 設備・サービスや現地精算機のタグに使用する */
export type ParkingTag = {
  name: string;
  inactiveName?: string;
  icon: Component;
  iconColor: {
    active: string;
  };
  textColor: {
    active: string;
  };
};
